import { farmSubdivisions } from './farmSubdivisions'
import { monitoring } from './monitoring'
import { quantificationUnits } from './quantificationUnits'

export const v2 = {
  farmSubdivisions,
  monitoring,
  quantificationUnits,
}
